import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserState {
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
  national_id: string;
  is_email_verified: boolean;
  is_colleague: boolean;
  setUser: (userData: Partial<UserState>) => void;
  setIsColleague: (value: boolean) => void;
  resetUser: () => void;
}

const initialState = {
  first_name: '',
  last_name: '',
  email: '',
  mobile: '',
  national_id: '',
  is_email_verified: false,
  is_colleague: false,
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      ...initialState,

      setUser: (userData) => set((state) => ({
        ...state,
        ...userData,
      })),

      setIsColleague: (value) => set({ is_colleague: value }),

      resetUser: () => set(initialState),
    }),
    {
      name: 'user-storage',
    },
  )
);